import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import "assets/styles.css";

const KPI_ITEMS = [
  { key: "pointsToNextRank", title: "Points to next rank" },
  { key: "pointsToFirst", title: "Points to #1" },
  { key: "winRate", title: "Win rate" },
];

export default function SeasonKpiCards({ metrics, variant }) {
  const containerClass =
    variant === "header"
      ? "TDSeasonKpiCards TDSeasonKpiCards--header"
      : "TDSeasonKpiCards";

  return (
    <Box className={containerClass}>
      {KPI_ITEMS.map((item) => (
        <Box key={item.key} className="TDSeasonKpiCard">
          <div className="TDSeasonKpiCardTitle">{item.title}</div>
          <div className="TDSeasonKpiCardValue">
            {metrics?.[item.key] ?? "N/A"}
          </div>
        </Box>
      ))}
    </Box>
  );
}

SeasonKpiCards.propTypes = {
  metrics: PropTypes.shape({
    pointsToNextRank: PropTypes.string,
    pointsToFirst: PropTypes.string,
    winRate: PropTypes.string,
  }),
  variant: PropTypes.oneOf(["default", "header"]),
};

SeasonKpiCards.defaultProps = {
  metrics: {
    pointsToNextRank: "N/A",
    pointsToFirst: "N/A",
    winRate: "N/A",
  },
  variant: "default",
};
